import { Component, Prop, h, Host, Element } from '@stencil/core';

@Component({
  tag: 'pn-usp-promoter',
  styleUrl: 'pn-usp-promoter.scss',
})
export class PnUspPromoter {
  @Element() hostElement: HTMLElement;

  @Prop() heading: string = null;
  @Prop() headingExtension: string = null;
  @Prop() bodyText: string = null;
  @Prop() backgroundGradient: string = null;
  @Prop() fullWidth: boolean = false;
  @Prop() rightAlign: boolean = false;
  @Prop() hideMobileImage: boolean = false;

  private centerMobileContent() {
    const slot = this.hostElement.querySelector('[slot="illustration"]');
    if (this.hideMobileImage || slot == null) {
      return 'usp-promoter--hide-image-small-screen';
    }
    return "";
  }

  render() {
    const { fullWidth, rightAlign } = this;
    const classes = [
      'usp-promoter',
      fullWidth ? "usp-promoter--full-width" : "",
      rightAlign ? "usp-promoter--right-align" : "",
    ].join(' ');
    const hasHeadingExtension = this.headingExtension ? "usp-promoter__heading-extension" : "";

    return (
      <Host>
        <div class={` ${classes} ${this.centerMobileContent()}`} style={{ 'background': `${this.backgroundGradient}` }}>
          <div class="usp-promoter__content">
            <slot name="illustration"></slot>
            <div class="usp-promoter__content-wrapper">
              <h2 class={`usp-promoter__content-heading ${hasHeadingExtension}`}>
                <span>{this.heading}</span>
                {this.headingExtension ? <span>{this.headingExtension}</span> : null}
              </h2>
              <p class="usp-promoter__content-text">{this.bodyText}</p>
              <slot name="app-store"></slot>
              <slot name="usp-buttons"></slot>
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
